import { waapi, animate, utils, createDraggable, spring, onScroll } from 'animejs';

const controlFilterVideos = () => {
    
    // --- Feature 1 & 3: Helper to manage selection state, URL, and filtering ---
    const updateSelectionState = (linkElement, category) => {
        // Get all filter links to manage 'selected' class
        const allLinks = document.querySelectorAll('.filter-link a');
        
        if (!linkElement || !category) return;

        // Check if we are deselecting (clicking the already selected one)
        // Feature 3: If selecting an already selected filter, clear it.
        const isAlreadySelected = linkElement.parentElement.classList.contains('selected');

        let targetCategory = category;
        let targetHash = category;

        if (isAlreadySelected) {
            // Deselect logic: Reset to 'all' and clear hash
            targetCategory = '#all';
            targetHash = ''; 
        } else {
            // Select logic
            targetHash = category;
        }

        // Feature 1: Update URL Hash
        if (targetHash) {
            history.pushState(null, null, location.pathname + '#' + targetHash.replace('#', ''));
        } else {
            history.pushState(null, null, location.pathname);
        }

        // Feature 1: Update 'selected' class on links
        allLinks.forEach(link => link.parentElement.classList.remove('selected'));
        if (!isAlreadySelected) {
            linkElement.parentElement.classList.add('selected');
        } else {
            document.querySelectorAll('.filter-link a').forEach(link => link.parentElement.classList.remove('selected'));
        }

        // Apply the filter animation logic
        filterBlocks(targetCategory);
    };

    // --- Feature 2: On Load Initialization ---
    const initFromURL = () => {
        const urlHash = window.location.hash;
        
        if (urlHash) {
            // Find the link matching the current hash
            const allLinks = document.querySelectorAll('.filter-link a');
            let foundLink = null;

            allLinks.forEach(link => {
                if (link.getAttribute('href') === urlHash) {
                    foundLink = link;
                }
            });

            if (foundLink) {
                // Apply selection state based on URL
                updateSelectionState(foundLink, urlHash);
            } else {
                // If hash doesn't match a valid filter, default to 'all' and clear class
                const allLinksArray = Array.from(allLinks);
                allLinksArray.forEach(link => link.parentElement.classList.remove('selected'));
                filterBlocks('#all');
                history.pushState(null, null, location.pathname);
            }
        } else {
            // Ensure clean state on fresh load if no hash
             document.querySelectorAll('.filter-link a').forEach(link => link.parentElement.classList.remove('selected'));
        }
    };

    // --- Main Logic: Filter Link Clicks ---
    const filterBlocks = (category) => {
        const blocks = document.querySelectorAll('.block_profile--selector');
        
        let cleanCategory = category.includes('#') ? category.substring(1) : category;

        blocks.forEach(block => {
            const matches = cleanCategory === 'all' || block.classList.contains(cleanCategory);
            
            if (matches) {
                block.style.display = 'block'; 
                
                animate(block, {
                    scale: [0.5, 1],
                    duration: 400,
                    easing: 'easeOutBack'
                });
            } else {
                animate(block, {
                    scale: [1, 0.5],
                    duration: 300,
                    easing: 'easeInBack',
                    complete: () => {
                        block.style.display = 'none'; 
                    }
                });
            }
        });
    };

    // Attach Click Event Listeners
    document.querySelectorAll('.filter-link a').forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault(); 

            const category = this.getAttribute('href');
            
            updateSelectionState(this, category);
        });
    })

    // Initialize based on current URL hash when function runs
    initFromURL();


    // --- Remaining Existing Code for Profile Content Toggling ---
    
    // --- Configuration ---
    const ANIMATION_DURATION = 1000; 
    
    // --- State ---
    let activeContent = null;

    // --- Feature 4: Helper to manage profile selector selection state ---
    function updateProfileSelectorState(selectorElement) {
        if (!selectorElement) return;

        const allSelectors = document.querySelectorAll('.block_profile--righthand-selector, .block_profile--selector');
        
        const isAlreadySelected = selectorElement.classList.contains('selected');
        
        allSelectors.forEach(select => select.classList.remove('selected'));
        
        if (isAlreadySelected) return;

        let identifier = '';
        for (let className of selectorElement.classList.values()) {
            if (className.startsWith('block_profile--name-')) {
                identifier = className; 
                break;
            }
        }

        if (identifier) {
            document.querySelectorAll(`.${identifier}`).forEach(el => {
                el.classList.add('selected');
            });
        } else {
            selectorElement.classList.add('selected');
        }
    }

    // --- Helper: Get matching content element ---
    function getMatchingContent(selectorElement) {
        const selectorClassList = selectorElement.classList;
        
        let identifier = '';
        for (let className of selectorClassList.values()) {
            if (className.startsWith('block_profile--name-')) {
                identifier = className; 
                break;
            }
        }

        // console.log('identifier')
        // console.log(identifier)

        if (!identifier) return null;

        return document.querySelector(`.block_profile--content.${identifier}`);
    }

    // --- Animation Utility: Fade Out ---
    function fadeOut(element, onComplete) {
       element.style.display = 'none';
       return 'done'
    }

    // --- Animation Utility: Fade In ---
    function fadeIn(element) {
        element.style.display = 'block';
        return 'done'
    }

    // --- Handler: Show Profile ---
    function handleProfileClick(selectorElement) {
        const targetContent = getMatchingContent(selectorElement);

        if (!targetContent) return;

        // Requirement: "fade in block_profile--container"
        const container = document.querySelector(`.block_profile--container`); 

        // Update profile selector state (Feature 4)
        updateProfileSelectorState(selectorElement);

        if (activeContent && activeContent !== targetContent) {
            // console.log('switching')
            
            fadeIn(container);
            fadeIn(targetContent);
            
            document.querySelectorAll('.block_profile--content').forEach(element => element.style.display = 'none');

            targetContent.style.display = 'block';
            activeContent = targetContent;
            
        } else {
            // First time showing or switching to same
            fadeIn(container);
            fadeIn(targetContent);
            activeContent = targetContent;
        }
    }

    // --- Event Listeners: Selectors ---
    const selectors = document.querySelectorAll('.block_profile--selector, .block_profile--righthand-selector');
    
    selectors.forEach(selector => {
        selector.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent any default behavior
            
            const isRighthand = event.currentTarget.classList.contains('block_profile--righthand-selector');

            // Apply the "Hide old -> Show new" logic universally
            if (isRighthand && activeContent) {
                handleProfileClick(event.currentTarget);
            } else {
                handleProfileClick(event.currentTarget);
            }
        });
    });

    // --- Event Listeners: Reset ---
    const resetBtn = document.querySelector('.block_profile--reset');
    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            const allContainers = document.querySelectorAll('.block_profile--container');
            const allContents = document.querySelectorAll('.block_profile--content');

            // Remove selected state from profile selectors
            const allSelectors = document.querySelectorAll('.block_profile--righthand-selector, .block_profile--selector');
            allSelectors.forEach(sel => sel.classList.remove('selected'));

            // Animate out everything currently visible
            [...allContainers, ...allContents].forEach(el => {
                if (el.style.display !== 'none') {
                    fadeOut(el);
                }
            });

            // Clear state
            activeContent = null;
            
            setTimeout(() => {
                allContainers.forEach(c => c.style.display = 'none');
                allContents.forEach(c => c.style.display = 'none');
            }, ANIMATION_DURATION + 50);
        });
    }

    // --- Initialization: Hide all blocks initially ---
    const initialContainers = document.querySelectorAll('.block_profile--container');
    const initialContents = document.querySelectorAll('.block_profile--content');
    
    initialContainers.forEach(el => el.style.display = 'none');
    initialContents.forEach(el => el.style.display = 'none');

}

export { controlFilterVideos }
